module.exports = __webpack_public_path__ + "img/big-poster.0be3fb0b.png";